import { axios } from '~/libs/axios';
import { type TUser } from '~/types';

const getCurrentUser = async (): Promise<TUser> => {
  const { data: user } = await axios.get<TUser>('/users/current_user');
  return user;
};

export const userAPI = {
  getCurrentUser,
};
